import { CalendarDays } from "lucide-react";
import type { WidgetDef } from "../types";
import { CalendarGlance, CalendarView } from "./CalendarWidget";
import { CalendarSettings } from "./CalendarSettings";
import { defaultCalendarConfig, parseCalendarConfig, type CalendarConfig } from "./config";

export const calendarWidget: WidgetDef<CalendarConfig> = {
  type: "calendar",
  icon: CalendarDays,
  title: "calendar.title",
  description: "calendar.description",
  sizes: ["s", "m", "l"],
  defaultSize: "l",
  defaultConfig: defaultCalendarConfig,
  parseConfig: parseCalendarConfig,
  available: (me) => me.role !== "carrier",
  View: CalendarView,
  Glance: CalendarGlance,
  Settings: CalendarSettings,
};
